export const HomeRouteNames = {
  WELCOME: '',
  PSEUDO_LOGIN: 'login',
  SESSION_SELECT: 'session',
} as const;
